import type { Middleware } from 'openapi-fetch'

import { getSession } from '@/features/auth/session-store'

/**
 * Puts the session's credentials on an outgoing request.
 *
 * Exported separately from the middleware because the refresh middleware has to
 * apply them again when it retries a request with a renewed token.
 */
export function applyAuthHeaders(headers: Headers): void {
  const { accessToken, authenticated, clientSessionId, webSocketId } = getSession()

  if (authenticated && accessToken !== null) {
    headers.set('Authorization', `JWT ${accessToken}`)
    headers.set('ClientSessionId', clientSessionId)
  }

  // Sent whether or not there is a session: it is what stops the realtime backend
  // echoing this tab's own mutations back to it, and public views mutate rows
  // through a form without one.
  headers.set('WebSocketId', webSocketId)
}

export const authMiddleware: Middleware = {
  onRequest({ request }) {
    applyAuthHeaders(request.headers)
    return request
  },
}
